import { Link } from 'react-router-dom';
import React, { PureComponent, Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { LazyImage } from 'react-lazy-images';
import get from 'lodash/get';

import { fetchDetailedRecipe } from './actions';
import MetaTags from '../../components/meta';
import Modal from '../../components/modal/Modal';
import ImageClient from '../../helpers/imageHandler';

import playBtn from '../../assets/img/play-btn.png';
import arrowIcon from '../../assets/img/next-icon-gradient.svg';
import fbIcon from '../../assets/img/fb-icon.svg';
import pinIcon from '../../assets/img/pin-icon.svg';
import twIcon from '../../assets/img/tw-icon.svg';
import printIcon from '../../assets/img/print-icon.svg';

import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton
} from 'react-share';

import './recipes.scss';

const ReactPlayer = lazy(() => import('react-player'));

class Recipe extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            link: '',
            isScroll: false
        }

        this.handleScroll = this.handleScroll.bind(this);
        this.handleOpenModal = this.handleOpenModal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.getUrl = this.getUrl.bind(this)
    }

    componentDidMount() {
        this.props.fetchDetailedRecipe(this.props.match.params.slug);
        document.addEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        const isScroll = window.pageYOffset > 300;
        if (isScroll !== this.state.isScroll && window.innerWidth > 768) {
            this.setState({ isScroll })
        }
    }

    handleOpenModal(link) {
        this.setState({ display: 'block', link })
    }

    handleCloseModal() {
        this.setState({ display: '', link: '' })
    }

    getUrl() {
        const url = this.state.link
        const videoId = url.substring(url.lastIndexOf('/') + 1)
        const processedUrl = `https://youtube.com/embed/${videoId}`

        return processedUrl
    }
    onEnded = () => {
        this.setState({ display: '', link: '' })
    }

    getIngredientLine(ingredient, index) {
        const { amount, weight, ingredient: goods, notes, blankLine } = ingredient;
        const explanation = notes ? `${goods}, ${notes}` : goods;
        const ingr = notes ? <>{goods}<span className="notes">{notes}</span></> : goods;
        return (
            <li key={index} className={blankLine ? 'with-blank-line' : ''}>
                <span>{amount} {weight}</span>
                <span className="ingredient">
                    {ingr}
                    <div className="no-print">
                        {explanation.toLowerCase().includes("ken's") && (
                            <Link
                                to={`/locator/${this.props.recipe.relatedProduct.slug}`}
                            >
                                &nbsp;All out? See which stores might
                                carry this.{' '}
                                <img
                                    className="arrow-link"
                                    src={arrowIcon}
                                    alt="see more"
                                />
                            </Link>
                        )}
                    </div>
                </span>
            </li>
        )
    }

    getDirectionLine(direction, index) {
        const classes = ['flex-block'];
        if (direction.blankLine) {
            classes.push('with-blank-line');
        }
        return (
            <div className={classes.join(' ')} key={index}>
                <div className="direction">
                    <span>{index + 1}</span>
                    <div>{direction.step}</div>
                </div>
                {direction.image ? (
                    <img src={direction.image} alt="" />
                ) : null}
            </div>
        )
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
    }

    render() {
        const { origin, href } = window.location;
        const { recipe } = this.props;
        const {
            name,
            image,
            slug,
            video,
            recipeDescription = {},
            courses = [],
            primaryIngredients = [],
            ingredients = {},
            directions = [],
        } = recipe;
        const { dressing, time, img } = recipeDescription;
        const { list = [] } = ingredients;
        const shouldShowDetails = recipe && !!recipe.id;
        const productThumbPath = img && ImageClient.fitIn(img, { width: 200, height: 278 });
        const recipeImage = image && ImageClient.fitIn(image, { width: 1920, height: 1280 });
        const deeplinkPath = `${origin}/api/deeplink?t=recipes&s=${slug}`;

        return (
            <>
                {!shouldShowDetails && (
                    <div className="body-wrapper">
                        <p className="loading">Loading ...</p>
                    </div>
                )}
                {shouldShowDetails && (
                    <div className="body-wrapper column recipe-details">
                        <MetaTags
                            title={get(recipe, ['seo', 'title'])}
                            keywords={get(recipe, ['seo', 'keyword'])}
                            description={get(recipe, ['seo', 'description'])}
                        />
                        <div className="recipe-container">
                            <h1>{name}</h1>
                            <div className="sause-image">
                                <LazyImage
                                    className="no-print"
                                    src={productThumbPath}
                                    alt="product thumbnail"
                                    placeholder={({ imageProps, ref }) => (
                                        <div ref={ref}></div>
                                    )}
                                    actual={({ imageProps }) => <img alt="" {...imageProps} />}
                                />
                                <img
                                    className="img-for-print"
                                    src={productThumbPath}
                                    alt="product thumbnail"
                                    placeholder={({ imageProps, ref }) => (
                                        <div ref={ref}></div>
                                    )}
                                />
                            </div>
                            <div className="table-container">
                                <div className="sause-table">
                                    <div className="label">DRESSING</div>
                                    <div className="underline"></div>
                                    <div
                                        className="sause-link"
                                        onClick={() =>
                                            this.props.history.push(
                                                `/products/${recipe.relatedProduct.slug}`
                                            )
                                        }
                                    >
                                        {dressing}
                                        <img
                                            className="arrow-link"
                                            src={arrowIcon}
                                            alt="dressing"
                                        />
                                    </div>
                                </div>
                                <div className="sause-table">
                                    <div className="label">COURSES</div>
                                    <div className="underline"></div>
                                    <ul className="info-list">
                                        {this.props.recipe.courses &&
                                            !!this.props.recipe.courses.length &&
                                            courses.map((course, index) => (
                                                <li key={index}>{course}</li>
                                            ))}
                                    </ul>
                                </div>
                                <div className="sause-table">
                                    <div className="label">PRIMARY INGREDIENT</div>
                                    <div className="underline"></div>
                                    <ul className="info-list">
                                        {this.props.recipe.primaryIngredients &&
                                            !!this.props.recipe.primaryIngredients
                                                .length &&
                                            primaryIngredients.map(
                                                (ingredient, index) => (
                                                    <li key={index}>{ingredient}</li>
                                                )
                                            )}
                                    </ul>
                                </div>
                                <div className="sause-table">
                                    <div className="label">TIME</div>
                                    <div className="underline"></div>
                                    <div>{time} Minutes</div>
                                </div>
                            </div>
                        </div>

                        <div className="recipe-img-container">
                            <ul className={`${this.state.isScroll ? 'social-links fixed' : 'social-links'}`}>
                                <li>
                                    <FacebookShareButton url={deeplinkPath} resetButtonStyle={false}>
                                        <img src={fbIcon} alt="Facebook post" /> Post
                                    </FacebookShareButton>
                                </li>

                                <li>
                                    <PinterestShareButton
                                        url={href}
                                        media={image}
                                        resetButtonStyle={false}
                                    >
                                        <img src={pinIcon} alt="Pinterest share" /> Pin
                                    </PinterestShareButton>
                                </li>

                                <li>
                                    <TwitterShareButton
                                        url={deeplinkPath}
                                        title={recipe.seo.title}
                                        resetButtonStyle={false}
                                    >
                                        <img src={twIcon} alt="Tweeter share" /> Tweet
                                    </TwitterShareButton>
                                </li>
                                {/* eslint-disable-next-line */}
                                <li><a href="" onClick={e => {
                                    e.preventDefault()
                                    window.print()
                                }}><img src={printIcon} alt="Print recipe" /> Print</a></li>
                            </ul>
                            <div className="recipe-img">
                                {recipe.video ? (
                                    <>
                                        <div
                                            className="video-block no-print"
                                            data-gtm-video-link-a
                                            style={{ backgroundImage: `url(${image})` }}
                                            onClick={() => this.handleOpenModal(video)}
                                        >
                                            <img
                                                className="video-play-button"
                                                src={playBtn}
                                                alt="play button"
                                            />
                                        </div>
                                    </>
                                ) : (
                                    <LazyImage
                                        className="no-print"
                                        alt="recipe"
                                        src={recipeImage}
                                        placeholder={({ imageProps, ref }) => (
                                            <div ref={ref}></div>
                                        )}
                                        actual={({ imageProps }) => <img alt="" {...imageProps} />}
                                    />
                                )}
                                <img
                                    className="img-for-print"
                                    alt="recipe"
                                    src={recipeImage}
                                />
                            </div>
                        </div>

                        <Modal
                            visible={this.state.display}
                            onClose={this.handleCloseModal}
                        >
                            <div className="player-wrapper">
                                <Suspense fallback={null}>
                                    <ReactPlayer
                                        className="react-player"
                                        url={this.getUrl()}
                                        onEnded={this.onEnded}
                                        controls={true}
                                        width="100%"
                                        height="88%"
                                        config={{
                                            youtube: {
                                                preload: true,
                                                playerVars: { showinfo: 1 },
                                            },
                                        }}
                                    />
                                </Suspense>
                            </div>
                        </Modal>

                        <div className="recipe-ingredients">
                            <h2>Ingredients</h2>
                            <ul>
                                {this.props.recipe.ingredients &&
                                    list.map((ingredient, index) => {
                                        return this.getIngredientLine(ingredient, index);
                                    })
                                }
                            </ul>
                        </div>
                        <div className="recipe-directions">
                            <h2>Directions</h2>
                            {this.props.recipe.directions &&
                                !!this.props.recipe.directions.length &&
                                directions.map((step, index) => {
                                    return this.getDirectionLine(step, index);
                                })}
                        </div>
                        <div className="print no-print">
                            <h2>
                                Great Job!
                                <br /> Print this recipe.
                            </h2>
                            <button
                                data-gtm-print-recipes-link-a
                                onClick={e => {
                                    e.preventDefault()
                                    window.print()
                                }}
                                className="print-link"
                            ></button>
                        </div>
                    </div>
                )}
            </>
        )
    }
}

const mapStateToProps = store => ({
    recipe: store.recipes.detailed,
})

export default connect(mapStateToProps, { fetchDetailedRecipe })(Recipe)
